import ApiUrl from "../../../configTools/api";
// Guarantees the callback fires exactly once with an array, even on failure - the page
// clears its loading flag inside it, so a dropped request must not leave a shimmer spinning.
import { apiGetList } from "../../../configTools/apiGet";
const User = JSON.parse(localStorage.getItem("user-info"));

const Get = (setValues) => {
    apiGetList(ApiUrl.Admin_Labs, (list, body)=>{
        setValues(list);
    });
}

const Post = (body,setValues) => {
    fetch(ApiUrl.Admin_Labs,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            Get(setValues);
        }
        else{
            alert(data.response);
        }
    });
}


const Functions = {Get,Post};
export default Functions;